module.exports = {"fb":"#","yt":"#","insta":"#","phone":"+222 45 29 24 55 Or +222 36 33 38 99 ","mail":"sales@prolog.mr","adresss":{"fr":"ZRB 548B TVZ ","en":"ZRB 548B TVZ ","ar":"ZRB 548B تفرغ زينة"},"location":{"fr":"Nouakchott, Mauritania","en":"Nouakchott, Mauritania","ar":"انواكشوط. موريتانيا"},"coord":[-15.9813433,18.1077652],"mapToken":"pk.eyJ1IjoibW9vbHNieXRoZXdheSIsImEiOiJjamttcTEwZmYwNG55M3BwcG96b2tnb3RkIn0.YS7iCYgWxfJEgUD5-4KDxg"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/links.json
// module id = 165
// module chunks = 0 1